/**
 * @file standard-texts.ts
 * @description Тексты стартового шаблона «Стандартный» (phase19.28 этап А;
 * uiux-starter-site §2.1–2.4). Два вида:
 *   - `STARTER_HINT` — подсказки [З] «замените»: обращение к владельцу. Они
 *     же — реестр `STARTER_HINT_TEXTS` для предупреждения «На странице
 *     остался текст шаблона» (решение пользователя 2026-10-24, вопрос 2:
 *     предупреждение, не запрет, SB120);
 *   - `STARTER_TEXT` — нейтральный текст [О], который можно публиковать.
 *
 * Тексты заготовок, которые шаблон оставляет как есть, здесь повторены
 * явно и ставятся правкой: шаблон не зависит молча от текстов заготовок, а
 * реестр подсказок точно совпадает с тем, что лежит на странице.
 */

/** Подсказки [З]. Ключ — где стоит; значение — текст дословно по проекту. */
export const STARTER_HINT = {
  homeEyebrow: "Что вы продаёте — в двух-трёх словах",
  homeAbout: "Расскажите в двух-трёх предложениях, чем занимается ваш магазин и почему у вас стоит купить.",
  serviceDeliveryShort: "Способы и сроки доставки — в двух-трёх предложениях.",
  servicePayment: "Перечислите способы оплаты, которые принимаете.",
  serviceReturns: "Коротко опишите условия обмена и возврата.",
  serviceDeliveryFull: "Перечислите способы доставки и сроки.",
  faqShipTime: "Напишите срок сборки и отправки.",
  faqDeliveryCost:
    "Стоимость и срок рассчитываются при оформлении заказа по вашему адресу. Проверьте, что это так для ваших способов доставки.",
  faqPickup: "Если есть самовывоз — напишите адрес и часы. Если нет — удалите вопрос.",
  returnsAbout: "Коротко: в какой срок и как можно вернуть или обменять товар.",
  faqReturnDays: "Напишите срок так же, как в документе «Условия возврата».",
  faqRefund: "Опишите, куда и в какой срок вернутся деньги.",
  faqDefect: "Напишите, куда сообщить и что приложить: фото, номер заказа.",
  whereToFind: "Напишите, как добраться и в какие часы вы на месте. Если самовывоза нет — удалите этот блок.",
} as const;

/** Нейтральные тексты [О]. */
export const STARTER_TEXT = {
  toCatalog: "Перейти в каталог",
  howToBuy: "Как у нас купить",
  deliveryTitle: "Доставка и оплата",
  deliveryAbout: "Как мы доставляем заказы и какие способы оплаты принимаем.",
  aboutReturnsLink: "Подробнее о возврате",
  returnsTitle: "Возврат и обмен",
  fullTerms: "Полные условия",
  fullTermsAbout: "Порядок, сроки и исключения описаны в документе «Условия возврата».",
  openReturnsDoc: "Открыть условия возврата",
  contactsTitle: "Контакты",
  contactsAbout: "Как с нами связаться и где забрать заказ.",
  howToReach: "Как связаться",
  whereToFindTitle: "Где нас найти",
  documents: "Документы",
} as const;

/** Вопросы «Доставки и оплаты» (§2.2 п. 3). */
export const STARTER_FAQ_DELIVERY = [
  { q: "Как быстро вы отправляете заказ?", a: STARTER_HINT.faqShipTime },
  { q: "Сколько стоит доставка?", a: STARTER_HINT.faqDeliveryCost },
  { q: "Можно ли забрать заказ самому?", a: STARTER_HINT.faqPickup },
  { q: "Как можно оплатить?", a: STARTER_HINT.servicePayment },
] as const;

/** Вопросы «Возврата и обмена» (§2.3 п. 3). */
export const STARTER_FAQ_RETURNS = [
  { q: "Сколько дней есть на возврат?", a: STARTER_HINT.faqReturnDays },
  { q: "Как вернуть деньги?", a: STARTER_HINT.faqRefund },
  { q: "Что делать, если товар пришёл с браком?", a: STARTER_HINT.faqDefect },
] as const;
